<template>
  <component :is="component" class="py-5 py-md-7 py-lg-8">
    <TitleWidget v-if="title">{{ title }}</TitleWidget>

    <LoadingWidget v-if="loading" />

    <template v-else>
      <slot />
    </template>
  </component>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import { VContainer } from "vuetify/lib/components";

export default {
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false,
    },
    container: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    component() {
      return this.container ? "v-container" : "div";
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    VContainer,
  },
};
</script>

<style lang="scss" scoped>
.page-template {
  @media screen and (min-width: 960.001px) {
    padding-top: 170px;
  }
}
</style>
